<button matButton="outlined" [matMenuTriggerFor]="languageMenu" data-testid="language-selector-current-language-button">{{ currentLanguage | uppercase }}</button>
<mat-menu #languageMenu="matMenu" class="alternate-theme">
  @for (language of languages; track language) {
    @if (language !== currentLanguage) {
      <button mat-menu-item (click)="changeLanguage(language)" data-testid="language-selector">
        {{ language | uppercase }}
      </button>
    }
  }
</mat-menu>
